import { Phone, Mail, MapPin, ExternalLink } from "lucide-react";
import { BUSINESS } from "@/data/site";

export const Footer = () => {
  return (
    <footer
      id="contact"
      data-testid="site-footer"
      className="bg-[#0a1a3c] text-slate-300"
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-16 grid lg:grid-cols-3 gap-12">
        <div>
          <div className="flex items-center gap-3">
            <img
              src={BUSINESS.logo}
              alt="Iqaluit Cleaning & Maintenance logo"
              className="h-14 w-14 object-contain rounded-lg bg-white p-1"
            />
            <div className="leading-tight">
              <p className="font-display text-lg font-extrabold text-white">
                Iqaluit Cleaning
              </p>
              <p className="text-xs tracking-[0.22em] text-sky-300 uppercase font-semibold">
                &amp; Maintenance
              </p>
            </div>
          </div>
          <p className="mt-5 text-sm leading-relaxed text-slate-400 max-w-xs">
            Reliable, professional residential &amp; commercial cleaning proudly
            serving Iqaluit and the territory of Nunavut.
          </p>

          <div className="mt-6 space-y-3 text-sm">
            <a
              href={BUSINESS.phoneHref}
              data-testid="footer-phone"
              className="flex items-center gap-3 hover:text-white transition-colors"
            >
              <Phone className="h-4 w-4 text-sky-300" /> {BUSINESS.phone}
            </a>
            <a
              href={BUSINESS.emailHref}
              data-testid="footer-email"
              className="flex items-center gap-3 hover:text-white transition-colors"
            >
              <Mail className="h-4 w-4 text-sky-300" /> {BUSINESS.email}
            </a>
            <a
              href={BUSINESS.mapsLink}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-maps-link"
              className="flex items-start gap-3 hover:text-white transition-colors"
            >
              <MapPin className="h-4 w-4 text-sky-300 mt-0.5" />
              <span>
                {BUSINESS.address}
                <span className="ml-1 inline-flex items-center gap-1 text-sky-300">
                  (View on Maps <ExternalLink className="h-3 w-3" />)
                </span>
              </span>
            </a>
          </div>
        </div>

        <div>
          <h4 className="font-display text-sm font-bold uppercase tracking-wider text-white">
            Services
          </h4>
          <ul className="mt-5 space-y-3 text-sm">
            {[
              ["Commercial Cleaning", "#services"],
              ["Residential Move-In", "#services"],
              ["Residential Move-Out", "#services"],
              ["Our Work Gallery", "#gallery"],
              ["Request a Quote", "#quote"],
            ].map(([label, href]) => (
              <li key={label}>
                <a
                  href={href}
                  className="text-slate-400 hover:text-white transition-colors"
                >
                  {label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-display text-sm font-bold uppercase tracking-wider text-white">
            Find Us
          </h4>
          <div className="mt-5 overflow-hidden rounded-2xl border border-white/10">
            <iframe
              title="Iqaluit Cleaning & Maintenance location map"
              data-testid="footer-map-embed"
              src={BUSINESS.mapsEmbed}
              width="100%"
              height="220"
              style={{ border: 0 }}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              allowFullScreen
            />
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-5 lg:px-8 py-6 flex flex-col items-center gap-2 text-xs text-slate-500 text-center">
          <p data-testid="footer-credit">
            Website Created by{" "}
            <a
              href="https://www.GregMiceli.com"
              target="_blank"
              rel="noopener noreferrer"
              className="font-semibold text-sky-300 hover:text-white transition-colors"
            >
              www.GregMiceli.com
            </a>
          </p>
          <p>
            © {new Date().getFullYear()} Iqaluit Cleaning &amp; Maintenance. All
            rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};
